import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/neamatmim/Code/RedQ/startuplanding/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "getting-started"
    }}>{`Getting Started`}</h1>
    <p>{`After downloading and unzipping the project go to the project folder run:`}</p>
    <pre><code parentName="pre" {...{}}>{`cd your_project_name
`}</code></pre>
    <p>{`Inside the project, you can run some built-in commands:
to start development run:`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn dev
# or
npm run dev
`}</code></pre>
    <p>{`Open `}<a parentName="p" {...{
        "href": "http://localhost:3000"
      }}>{`dev server`}</a>{` to view it in the browser. The page will automatically reload if you make changes to the code. You will see the build errors and lint warnings in the console.`}</p>
    <p>{`to build the project run:`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn build
# or
npm run build
`}</code></pre>
    <p>{`to serve run:`}</p>
    <pre><code parentName="pre" {...{}}>{`yarn build
yarn start
# or
npm run build
npm run start
`}</code></pre>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      